import { adminProQueryOptions } from "api/queries/admin";
import { marketsQueryOptions } from "api/queries/markets";
import { proProfileQueryOptions } from "api/queries/pros";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  proProfileQueryOptions(input.id),
  adminProQueryOptions(input.id),
  marketsQueryOptions(),
];
